<template>
  <div class="app-shell">
    <AppNavbar v-if="showNavbar" />
    <main class="app-main">
      <router-view :key="route.fullPath" />
    </main>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppNavbar from './components/AppNavbar.vue'

const route = useRoute()
const showNavbar = computed(() => Boolean(route.meta.showNavbar))
</script>

<style>
*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body,
#app {
  margin: 0;
  height: 100%;
  min-height: 100vh;
  font-family: system-ui, -apple-system, sans-serif;
  color: #1f2937;
  background: #f8fafc;
}

button,
input {
  font: inherit;
}
</style>
